export default Object.freeze({
    en_US: 'en-US',
})
